// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type IdealEmployerMarkMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;

export type IdealEmployerMarkMutation = {
  __typename?: 'Mutation';
  proJobsMarkAsIdealEmployer?: {
    __typename?: 'ProJobsIdealEmployerMutationResult';
    error?: {
      __typename?: 'ProJobsIdealEmployerMutationError';
      message?: string | null;
    } | null;
  } | null;
};

export const IdealEmployerMarkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IdealEmployerMark' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'companyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'proJobsMarkAsIdealEmployer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'companyId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'companyId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IdealEmployerMarkMutation,
  IdealEmployerMarkMutationVariables
>;
